
export const Main = () => {
    return (
        <h1 style={{ maxWidth: '1366px' }}>Main page</h1>
    )
}